import { type RouteConfig } from 'vue-router'

export const ProgramsRouter: RouteConfig[] = [
  {
    path: '/programs',
    component: async () => import('./Programs.vue'),
  },
]
